import React from 'react'

const Correct = ({prop}) => {
  return (
    <>Correct! This is a phishing email</> 
  )
}

export default Correct